<template>
  <component
    v-bind="informationFieldExtraAttributes"
    :is="informationField"
    :name="name"
    :label="label"
    :value="value"
    :tip="tip"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    :placeholder="placeholder"
    @input="$emit('input', $event)"
  ></component>
</template>

<script>
import InputField from '@/compliance/components/new-query/step-information/information-field/InputField.vue';
import RadioField from '@/compliance/components/new-query/step-information/information-field/RadioField.vue';
import CheckboxField from '@/compliance/components/new-query/step-information/information-field/CheckboxField.vue';
import SelectField from '@/compliance/components/new-query/step-information/information-field/SelectField.vue';

export default {
  name: 'InformationField',

  props: {
    type: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
      default: '',
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    options: {
      required: false,
    },
    tip: {
      required: false,
      type: String,
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    required: {
      required: false,
      type: Boolean,
      default: true,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    /**
     * The field is a input radio.
     *
     * @returns {boolean}
     */
    isRadio() {
      return this.type === 'radio';
    },

    /**
     * The field is a input checkbox.
     *
     * @returns {boolean}
     */
    isCheckbox() {
      return this.type === 'checkbox';
    },

    /**
     * The field is a select.
     *
     * @returns {boolean}
     */
    isSelect() {
      return this.type === 'select';
    },

    /**
     * The information field component.
     *
     * @returns {RadioField|SelectField|InputField}
     */
    informationField() {
      if (this.isRadio) {
        return RadioField;
      }

      if (this.isCheckbox) {
        return CheckboxField;
      }

      if (this.isSelect) {
        return SelectField;
      }

      return InputField;
    },

    /**
     * The extra attributes from information field.
     *
     * @returns {{options: *}|{type: String}}
     */
    informationFieldExtraAttributes() {
      if (this.isRadio || this.isSelect) {
        return {
          options: this.options,
        };
      }

      return {
        type: this.type,
      };
    },
  },

  components: {
    InputField,
    RadioField,
    CheckboxField,
    SelectField,
  },
};
</script>

<style lang="scss" scoped>

</style>
